import {applyMiddleware, createStore, PreloadedState, Middleware, Reducer, Store} from 'redux'
import thunk from 'redux-thunk'
import {ControllerParams} from '@wix/yoshi-flow-editor'

interface StoreConfig<State, StoreExtraArgs> {
  reducers: Reducer
  initialData: PreloadedState<State>
  extraArguments: StoreExtraArgs
  middleware: Middleware[]
}

export const createReduxStore = <State, StoreExtraArgs>({
  reducers,
  initialData,
  extraArguments,
  middleware,
}: StoreConfig<State, StoreExtraArgs>) =>
  createStore(reducers, initialData, applyMiddleware(thunk.withExtraArgument(extraArguments), ...middleware))

export const subscribeToStateChanges = (controller: ControllerParams['controllerConfig'], store: Store) => {
  const onStateChange = () => {
    const state = store.getState()
    controller.setProps({state})
  }

  store.subscribe(onStateChange)
}
